import { Card, SectionLabel } from "@/components/common";
import { GraduationCap } from "lucide-react";

export const MODULES = [
  { cat: "Foundations", items: ["Market Structure", "Trend Following", "Support & Resistance", "Risk / Reward"] },
  { cat: "Setups", items: ["Pullbacks", "Breakouts", "False Breakouts", "Liquidity Sweeps", "Ranges", "Mean Reversion"] },
  { cat: "Risk & Money", items: ["Position Size", "Stop Loss", "Take Profit", "News Risk"] },
  { cat: "Process", items: ["Sessions", "Journaling", "Backtesting"] },
  { cat: "Psychology", items: ["Trading Psychology", "FOMO", "Revenge Trading"] },
];

const CONTENT = {
  "Pullbacks": "A pullback is a temporary move against the prevailing trend back toward value. Aurum waits for price to reach a logical zone (support, EMA, swing) and requires confirmation before considering entry — it never enters simply because price touched a level.",
  "Position Size": "Position size is derived from your account balance, risk %, and the distance to your structural stop. Dollar Risk = Balance × Risk%. Lots = Dollar Risk ÷ (Stop Distance × contract value). Aurum computes this deterministically for XAU/USD (100 oz per lot).",
  "Stop Loss": "A stop belongs where your trade idea is proven wrong — below structure for longs, above structure for shorts — with an ATR/volatility buffer. Never widen a stop just because a trade is losing.",
  "FOMO": "Fear of missing out drives chasing. If price has left the entry zone, the edge is gone. Aurum flags ENTRY MISSED — DO NOT CHASE to protect you.",
};

export default function LearnCenter() {
  return (
    <div className="space-y-5 animate-fade-up">
      <div className="flex items-center gap-3"><GraduationCap className="text-aurum" /><h1 className="text-2xl font-bold tracking-tight">Learning Center</h1></div>
      {MODULES.map((m) => (
        <div key={m.cat}>
          <SectionLabel>{m.cat}</SectionLabel>
          <div className="mt-3 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {m.items.map((it) => (
              <Card key={it} className="p-5 hover:border-aurum transition-colors" data-testid={`module-${it.replace(/\s|\//g, "-")}`}>
                <div className="font-medium">{it}</div>
                <p className="mt-2 text-xs text-[var(--text-muted)] leading-relaxed">
                  {CONTENT[it] || "Structured lesson covering the concept, how Aurum applies it, and common mistakes to avoid. No module promises profits."}
                </p>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
